import { RefreshCw } from 'lucide-react';

interface PullToRefreshIndicatorProps {
  pullDistance: number;
  pullProgress: number;
  isRefreshing: boolean;
}

export function PullToRefreshIndicator({
  pullDistance,
  pullProgress,
  isRefreshing,
}: PullToRefreshIndicatorProps) {
  if (pullDistance === 0 && !isRefreshing) return null;

  const rotation = pullProgress * 180;
  const opacity = Math.min(pullProgress * 1.5, 1);
  const scale = 0.5 + pullProgress * 0.5;

  return (
    <div
      className="pull-to-refresh-indicator"
      style={{
        height: `${pullDistance}px`,
        opacity: isRefreshing ? 1 : opacity,
      }}
    >
      <div
        className={`pull-to-refresh-icon ${isRefreshing ? 'refreshing' : ''}`}
        style={{
          transform: isRefreshing
            ? 'rotate(0deg)'
            : `rotate(${rotation}deg) scale(${scale})`,
        }}
      >
        <RefreshCw size={24} />
      </div>
      {pullProgress >= 1 && !isRefreshing && (
        <span className="pull-to-refresh-text">Release to refresh</span>
      )}
      {isRefreshing && (
        <span className="pull-to-refresh-text">Refreshing...</span>
      )}
    </div>
  );
}
